import { Link } from "react-router-dom";
import { LOGO_URL } from "../data/content";

const explore = [
  ["Chapter I", "/chapter-i"],
  ["Archive", "/archive"],
  ["Society", "/society"],
  ["About", "/about"],
  ["Journal", "/journal"],
];

const support = [
  ["Shipping", "/shipping-returns"],
  ["Returns", "/shipping-returns"],
  ["Privacy", "/privacy"],
  ["Terms", "/terms"],
];

const socials = [
  ["Instagram", "https://instagram.com/blackdogsociety.co"],
  ["TikTok", "https://tiktok.com"],
  ["YouTube", "https://youtube.com"],
];

export const Footer = ({ onJoin }) => (
  <footer data-testid="footer" className="relative border-t border-bds-border">
    <div className="mx-auto max-w-[1600px] px-6 md:px-12 py-16 md:py-24">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-20">
        <div className="md:col-span-5">
          <img
            src={LOGO_URL}
            alt="Black Dog Society"
            loading="lazy"
            className="w-64 md:w-80 h-auto object-contain mix-blend-screen select-none"
            draggable={false}
          />
          <p className="font-grotesk text-bds-muted max-w-md mt-8 leading-relaxed">
            An art-led clothing society from Wellington, New Zealand. If you or
            someone you love is struggling, please reach out — in NZ, call or text 1737.
          </p>
        </div>

        <nav className="md:col-span-2" aria-label="Explore">
          <p className="font-mono-bds text-[11px] uppercase tracking-[0.3em] text-bds-muted mb-6">Explore</p>
          <ul className="space-y-3 font-grotesk">
            {explore.map(([l, h]) => (
              <li key={l}>
                <Link to={h} data-testid={`footer-link-${l.toLowerCase().replace(/\s+/g, "-")}`} className="hover:text-bds-accent transition-colors">{l}</Link>
              </li>
            ))}
          </ul>
        </nav>

        <nav className="md:col-span-2" aria-label="Support">
          <p className="font-mono-bds text-[11px] uppercase tracking-[0.3em] text-bds-muted mb-6">Support</p>
          <ul className="space-y-3 font-grotesk">
            <li>
              <a href="mailto:hello@blackdogsociety.co.nz" data-testid="footer-contact" className="hover:text-bds-accent transition-colors">Contact</a>
            </li>
            {support.map(([l, h]) => (
              <li key={l}>
                <Link to={h} className="hover:text-bds-accent transition-colors">{l}</Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="md:col-span-3">
          <p className="font-mono-bds text-[11px] uppercase tracking-[0.3em] text-bds-muted mb-6">Follow</p>
          <ul className="space-y-3 font-grotesk">
            {socials.map(([l, h]) => (
              <li key={l}>
                <a
                  href={h}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`social-${l.toLowerCase()}`}
                  className="hover:text-bds-accent transition-colors"
                >
                  {l}
                </a>
              </li>
            ))}
            <li>
              <button onClick={onJoin} data-testid="footer-join-btn" className="hover:text-bds-accent transition-colors text-left">
                Enter the Society
              </button>
            </li>
          </ul>
        </div>
      </div>

      <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-8 border-t border-bds-border">
        <p className="font-mono-bds text-[11px] uppercase tracking-[0.2em] text-bds-muted">
          © {new Date().getFullYear()} Black Dog Society · Wellington, New Zealand
        </p>
        <p className="font-mono-bds text-[11px] uppercase tracking-[0.2em] text-bds-muted">
          You are not alone
        </p>
      </div>
    </div>
  </footer>
);
